'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

require('../../src/styles/external.scss');

var _avatar = require('../../src/assets/avatar.png');

var _avatar2 = _interopRequireDefault(_avatar);

var _practice = require('../../src/assets/practice.png');

var _practice2 = _interopRequireDefault(_practice);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewModal = function ReviewModal(props) {
	var className = props.className,
	    profileName = props.profileName,
	    profileImage = props.profileImage,
	    isOpen = props.isOpen,
	    agreeButtonActive = props.agreeButtonActive,
	    agreeButtonClicked = props.agreeButtonClicked,
	    nextButtonClicked = props.nextButtonClicked,
	    isCodeValid = props.isCodeValid,
	    validateCode = props.validateCode,
	    pageOneActive = props.pageOneActive,
	    pageTwoActive = props.pageTwoActive,
	    pageThreeActive = props.pageThreeActive,
	    starSelected = props.starSelected,
	    activeStar = props.activeStar,
	    setStarActive = props.setStarActive,
	    isReviewEmpty = props.isReviewEmpty,
	    submitButtonClicked = props.submitButtonClicked,
	    submitAttempted = props.submitAttempted,
	    onReviewBodyChange = props.onReviewBodyChange,
	    reviewData = props.reviewData,
	    profileType = props.profileType,
	    submitFailed = props.submitFailed,
	    nextButtonActive = props.nextButtonActive,
	    onReviewCodeChange = props.onReviewCodeChange,
	    reviewCode = props.reviewCode;


	var ONE_STAR = 1;
	var TWO_STARS = 2;
	var THREE_STARS = 3;
	var FOUR_STARS = 4;
	var FIVE_STARS = 5;
	var ENTER_KEY = 13;

	var textarea = void 0;
	var reviewModal = void 0;
	var overlay = void 0;

	return _react2.default.createElement(
		'div',
		{ ref: function ref(div) {
				reviewModal = div;
			}, className: className },
		isOpen && _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'div',
				{ className: _style2.default.modalBackground,
					onClick: function onClick(event) {
						if (event.target === overlay) {
							(0, _doctifyUtils.closeModal)(props, overlay);
						}
					},
					ref: function ref(div) {
						overlay = div;
						if (overlay) {
							overlay.addEventListener('wheel', (0, _doctifyUtils.stopScroll)(_style2.default.modalContainer, overlay), true);
							overlay.addEventListener('touchmove', (0, _doctifyUtils.stopScrollMobile)(_style2.default.modalContainer), true);
							overlay.addEventListener('touchstart', _doctifyUtils.setLastY, true);
						}
					} },
				pageOneActive && _react2.default.createElement(
					'form',
					{ className: _style2.default.modalContainerFirstAndLast + ' ' + _style2.default.modalContainer },
					_react2.default.createElement(
						'div',
						{ className: _style2.default.modalHeaderPageOne },
						_react2.default.createElement(
							'a',
							{ className: _style2.default.closeButton, onClick: function onClick() {
									return (0, _doctifyUtils.closeModal)(props, overlay);
								} },
							_react2.default.createElement('i', { className: 'ion-ios-close-empty' })
						),
						_react2.default.createElement(
							'h2',
							null,
							'Leave a Review'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.reviewCodeBar },
						_react2.default.createElement(
							'div',
							{ className: 'df-input-group' },
							_react2.default.createElement('i', { className: 'ion-ios-locked-outline' }),
							_react2.default.createElement('input', { className: 'form-control ' + (nextButtonActive && !isCodeValid && _style2.default.inputError),
								type: 'text',
								placeholder: 'Enter your Review Code',
								value: reviewCode,
								onChange: function onChange(event) {
									onReviewCodeChange(event.target.value);
								}
							}),
							_react2.default.createElement(
								'p',
								{ className: (nextButtonActive && !isCodeValid ? _style2.default.errorMessage : '') + ' ' + _style2.default.hiddenErrorMessage },
								'Your code is invalid.'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.buttonContainer },
						_react2.default.createElement(
							'button',
							{ onClick: function onClick(event) {
									validateCode(reviewCode).then(function () {
										(0, _doctifyUtils.fireGTMevent)('write_review_next');
										nextButtonClicked();
									});
									event.preventDefault();
								},
								type: 'submit', className: 'btn' },
							'Next'
						)
					),
					_react2.default.createElement(
						'p',
						{ className: _style2.default.modalFooterPageOne },
						'Don\'t have a review code? Please contact your specialist.'
					)
				),
				pageTwoActive && isCodeValid && _react2.default.createElement(
					'form',
					{ className: _style2.default.modalContainerPageTwo + ' ' + _style2.default.modalContainer },
					_react2.default.createElement(
						'div',
						{ className: _style2.default.modalHeader },
						_react2.default.createElement(
							'a',
							{ className: _style2.default.closeButton, onClick: function onClick() {
									return (0, _doctifyUtils.closeModal)(props, overlay);
								} },
							_react2.default.createElement('i', { className: 'ion-ios-close-empty' })
						),
						_react2.default.createElement('img', {
							src: profileImage || profileType === 'specialist' && _avatar2.default || profileType === 'practice' && _practice2.default,
							className: !profileImage && profileType === 'practice' && _style2.default.defaultPracticeImage
						}),
						_react2.default.createElement(
							'p',
							null,
							'Review your experience with ',
							_react2.default.createElement(
								'strong',
								null,
								profileName
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.modalBody },
						_react2.default.createElement(
							'div',
							{ className: _style2.default.selectRating },
							_react2.default.createElement(
								'p',
								{ className: _style2.default.instruction },
								'1) Select your rating *'
							),
							_react2.default.createElement('i', { className: _style2.default.tooltipRating + ' ion-information-circled' }),
							_react2.default.createElement(
								'div',
								{ className: _style2.default.reviewModalTooltipContainer + ' ' + _style2.default.tooltipContainerRating },
								'Your rating is anonymous and it will help the specialist provide a better service.'
							),
							_react2.default.createElement(
								'div',
								{ className: _style2.default.starRating },
								_react2.default.createElement(
									'div',
									{ className: _style2.default.rating },
									_react2.default.createElement('input', { name: 'rating', type: 'radio', id: '1-star' }),
									_react2.default.createElement(
										'label',
										{ onClick: function onClick() {
												return setStarActive(FIVE_STARS);
											}, htmlFor: '1-star' },
										_react2.default.createElement('i', { className: 'ion-ios-star-outline' })
									),
									_react2.default.createElement('input', { name: 'rating', type: 'radio', id: '2-star' }),
									_react2.default.createElement(
										'label',
										{ onClick: function onClick() {
												return setStarActive(FOUR_STARS);
											}, htmlFor: '2-star' },
										_react2.default.createElement('i', { className: 'ion-ios-star-outline' })
									),
									_react2.default.createElement('input', { name: 'rating', type: 'radio', id: '3-star' }),
									_react2.default.createElement(
										'label',
										{ onClick: function onClick() {
												return setStarActive(THREE_STARS);
											}, htmlFor: '3-star' },
										_react2.default.createElement('i', { className: 'ion-ios-star-outline' })
									),
									_react2.default.createElement('input', { name: 'rating', type: 'radio', id: '4-star' }),
									_react2.default.createElement(
										'label',
										{ onClick: function onClick() {
												return setStarActive(TWO_STARS);
											}, htmlFor: '4-star' },
										_react2.default.createElement('i', { className: 'ion-ios-star-outline' })
									),
									_react2.default.createElement('input', { name: 'rating', type: 'radio', id: '5-star' }),
									_react2.default.createElement(
										'label',
										{ onClick: function onClick() {
												return setStarActive(ONE_STAR);
											}, htmlFor: '5-star' },
										_react2.default.createElement('i', { className: 'ion-ios-star-outline' })
									)
								),
								_react2.default.createElement(
									'span',
									null,
									activeStar === ONE_STAR ? 'Poor' : '',
									activeStar === TWO_STARS ? 'Average' : '',
									activeStar === THREE_STARS ? 'Good' : '',
									activeStar === FOUR_STARS ? 'Very Good' : '',
									activeStar === FIVE_STARS ? 'Excellent' : ''
								)
							),
							_react2.default.createElement(
								'p',
								{ className: (submitAttempted && !starSelected ? _style2.default.errorMessage : '') + ' ' + _style2.default.hiddenErrorMessage },
								'You must select a rating.'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _style2.default.writeReview },
							_react2.default.createElement(
								'p',
								{ className: _style2.default.instruction },
								'2) Write your review *'
							),
							_react2.default.createElement('textarea', {
								className: (submitAttempted ? _style2.default.inputError : '') + ' form-control',
								ref: function ref(input) {
									textarea = input;
								},
								onChange: function onChange(event) {
									onReviewBodyChange(event.target.value);
								},
								placeholder: 'Write your review here...'
							}),
							_react2.default.createElement('i', { className: _style2.default.tooltipReview + ' ion-information-circled' }),
							_react2.default.createElement(
								'div',
								{ className: _style2.default.reviewModalTooltipContainer + ' ' + _style2.default.tooltipContainerReview },
								'Your review is anonymous and it will help the specialist provide a better service.'
							),
							_react2.default.createElement(
								'p',
								{ className: '' + (submitAttempted && isReviewEmpty ? _style2.default.errorMessage : _style2.default.hiddenErrorMessage) },
								'You must leave a review in the box above.'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _style2.default.termsAndConditions + ' df-checkbox' },
							_react2.default.createElement('input', { id: 'agree-terms', className: 'form-control', type: 'checkbox' }),
							_react2.default.createElement(
								'label',
								{ onClick: function onClick() {
										return agreeButtonClicked();
									}, className: agreeButtonActive ? '' + _style2.default.labelActive : '', htmlFor: 'agree-terms' },
								'I certify that this review is based on my personal experience with this health specialist, with whom I have no personal or business relationship. I understand that Doctify has zero-tolerance towards false/misleading reviews. *'
							),
							_react2.default.createElement(
								'p',
								{ className: (submitAttempted && !agreeButtonActive ? _style2.default.errorMessage : '') + ' ' + _style2.default.hiddenErrorMessage },
								'You must agree to the terms and conditions.'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _style2.default.requiredKey },
							_react2.default.createElement(
								'p',
								null,
								'* indicates required field'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'agree-review text-center' },
							' By submitting this form you agree to ',
							_react2.default.createElement(
								'a',
								{ href: '/terms-and-conditions#review-of-health-specialist-services' },
								'Doctify\'s Terms & Conditions'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _style2.default.submitButtonContainer },
							_react2.default.createElement(
								'button',
								{
									className: 'btn',
									type: 'submit',
									onClick: function onClick(event) {
										if (starSelected && !isReviewEmpty && agreeButtonActive) {
											submitButtonClicked(reviewData, profileType).then(function () {
												(0, _doctifyUtils.fireGTMevent)('write_review_submit', profileName.toLowerCase().replace(/\s/g, '_'));
												(0, _doctifyUtils.fireGTMevent)('star_review_submit', profileName.toLowerCase().replace(/\s/g, '_') + '_5');
											});
										} else {
											submitFailed();
										}
										event.preventDefault();
									} },
								'Submit'
							)
						)
					)
				),
				pageThreeActive && isCodeValid && !isReviewEmpty && agreeButtonActive && starSelected && _react2.default.createElement(
					'div',
					{ className: _style2.default.modalContainerFirstAndLast + ' ' + _style2.default.modalContainer },
					_react2.default.createElement(
						'div',
						{ className: _style2.default.modalHeaderPageThree },
						_react2.default.createElement(
							'a',
							{ className: _style2.default.closeButton, onClick: function onClick() {
									return (0, _doctifyUtils.closeModal)(props, overlay);
								} },
							_react2.default.createElement('i', { className: 'ion-ios-close-empty' })
						),
						_react2.default.createElement(
							'h2',
							null,
							_react2.default.createElement('i', { className: 'ion-ios-checkmark-outline' }),
							'Success'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.modalBodyPageThree },
						_react2.default.createElement(
							'p',
							null,
							'Thank you for using Doctify! We have received your review. Once it has been approved, it will be visible on Doctify.co.uk. If you have any questions please contact us at ',
							_react2.default.createElement(
								'a',
								{ href: 'mailto:customerservice@doctify.co.uk' },
								'customerservice@doctify.co.uk'
							),
							'.'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.submitButtonContainer },
						_react2.default.createElement(
							'button',
							{ className: 'btn', onClick: function onClick() {
									return (0, _doctifyUtils.closeModal)(props, overlay);
								} },
							'Close'
						)
					)
				)
			)
		)
	);
};

ReviewModal.propTypes = {
	className: require('react').PropTypes.string.isRequired,
	profileName: require('react').PropTypes.string.isRequired,
	profileImage: require('react').PropTypes.string.isRequired,
	isOpen: require('react').PropTypes.bool.isRequired,
	agreeButtonActive: require('react').PropTypes.bool.isRequired,
	agreeButtonClicked: require('react').PropTypes.func.isRequired,
	closeModal: require('react').PropTypes.func.isRequired,
	isCodeValid: require('react').PropTypes.bool.isRequired,
	validateCode: require('react').PropTypes.func.isRequired,
	pageOneActive: require('react').PropTypes.bool.isRequired,
	pageTwoActive: require('react').PropTypes.bool.isRequired,
	pageThreeActive: require('react').PropTypes.bool.isRequired,
	nextButtonClicked: require('react').PropTypes.func.isRequired,
	starSelected: require('react').PropTypes.bool.isRequired,
	activeStar: require('react').PropTypes.number.isRequired,
	setStarActive: require('react').PropTypes.func.isRequired,
	isReviewEmpty: require('react').PropTypes.bool.isRequired,
	submitButtonClicked: require('react').PropTypes.func.isRequired,
	submitAttempted: require('react').PropTypes.func.isRequired,
	onReviewBodyChange: require('react').PropTypes.func.isRequired,
	reviewData: require('react').PropTypes.object.isRequired,
	profileType: require('react').PropTypes.string.isRequired,
	submitFailed: require('react').PropTypes.func.isRequired,
	nextButtonActive: require('react').PropTypes.bool.isRequired,
	onReviewCodeChange: require('react').PropTypes.func.isRequired,
	reviewCode: require('react').PropTypes.string.isRequired
};
ReviewModal.displayName = 'ReviewModal';

ReviewModal.defaultProps = {
	className: 'reviewModal',
	isOpen: 'false',
	profileName: '',
	profileImage: '',
	agreeButtonActive: false,
	agreeButtonClicked: function agreeButtonClicked() {},
	closeModal: function closeModal() {},
	nextButtonActive: false,
	isCodeValid: false,
	pageOneActive: true,
	pageTwoActive: false,
	pageThreeActive: false,
	nextButtonClicked: function nextButtonClicked() {},
	starSelected: false,
	activeStar: '',
	setStarActive: function setStarActive() {},
	isReviewEmpty: true,
	submitButtonClicked: function submitButtonClicked() {},
	submitAttempted: function submitAttempted() {},
	reviewData: {}
};

exports.default = ReviewModal;


// WEBPACK FOOTER //
// ./components/review-modal/lib/components/review-modal.js